import React from 'react';
import { motion } from 'framer-motion';
import { Button, SectionHeader } from './ui/Shared';
import { Mail, Instagram, MapPin } from 'lucide-react';
import { FullLogo } from './ui/Logo';
export const Contact = () => {
  return <section id="contact" className="py-24 bg-ivory relative border-b border-bronze/20" data-id="element-58">
      <div className="absolute inset-0 bg-noise pointer-events-none" data-id="element-59" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-60">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-61">
          <div data-id="element-62">
            <SectionHeader title="Get in touch." subtitle="Have questions about the fellowship? Reach out to our team." data-id="element-63" />

            <div className="space-y-6 mt-8" data-id="element-64">
              <ContactItem icon={<MapPin size={20} data-id="element-66" />} text="Brampton, ON (Location details provided upon acceptance)" delay={0.1} data-id="element-65" />
              <ContactItem icon={<Mail size={20} data-id="element-68" />} text="info@thesikhinitiative.org" delay={0.2} data-id="element-67" />
              <ContactItem icon={<Instagram size={20} data-id="element-70" />} text="@sikhinitiative" delay={0.3} data-id="element-69" />
            </div>
          </div>

          <motion.form initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-parchment/50 border border-bronze/20 p-8 rounded-sm hover:border-kesari/30 transition-colors shadow-sm" onSubmit={e => e.preventDefault()} data-id="element-71">
            <div className="space-y-4" data-id="element-72">
              <div data-id="element-73">
                <label className="block text-xs font-sans text-navy uppercase tracking-wider font-semibold mb-2" data-id="element-74">
                  Name
                </label>
                <input type="text" className="w-full bg-ivory border border-bronze/30 px-4 py-3 rounded-sm focus:outline-none focus:border-kesari focus:ring-1 focus:ring-kesari transition-all font-sans" placeholder="Jane Doe" data-id="element-75" />
              </div>
              <div data-id="element-76">
                <label className="block text-xs font-sans text-navy uppercase tracking-wider font-semibold mb-2" data-id="element-77">
                  Email
                </label>
                <input type="email" className="w-full bg-ivory border border-bronze/30 px-4 py-3 rounded-sm focus:outline-none focus:border-kesari focus:ring-1 focus:ring-kesari transition-all font-sans" placeholder="jane@example.com" data-id="element-78" />
              </div>
              <div data-id="element-79">
                <label className="block text-xs font-sans text-navy uppercase tracking-wider font-semibold mb-2" data-id="element-80">
                  Message
                </label>
                <textarea rows={4} className="w-full bg-ivory border border-bronze/30 px-4 py-3 rounded-sm focus:outline-none focus:border-kesari focus:ring-1 focus:ring-kesari transition-all font-sans resize-none" placeholder="How can we help?" data-id="element-81"></textarea>
              </div>
              <Button variant="outline" className="w-full" data-id="element-82">
                Send Message
              </Button>
            </div>
          </motion.form>
        </div>
      </div>
    </section>;
};
const ContactItem = ({
  icon,
  text,
  delay
}: {
  icon: React.ReactNode;
  text: string;
  delay: number;
}) => <motion.div initial={{
  opacity: 0,
  x: -20
}} whileInView={{
  opacity: 1,
  x: 0
}} viewport={{
  once: true
}} transition={{
  delay
}} className="flex items-center gap-4 text-charcoal/80 font-sans group cursor-default" data-id="element-83">
    <div className="w-10 h-10 bg-parchment flex items-center justify-center rounded-sm text-gold group-hover:bg-kesari group-hover:text-ivory transition-colors shadow-sm" data-id="element-84">
      {icon}
    </div>
    <span className="group-hover:text-kesari transition-colors" data-id="element-85">{text}</span>
  </motion.div>;